<template>
  <section>
    <Navbar />
    <Universal />
  </section>
</template>

<script>
import Navbar from "../components/Navbar.vue";
import Universal from "../components/Universal.vue";

export default {
  name: "MainPage",
  components: {
    Navbar,
    Universal
  },
  props: {
    locality: {
      type: String,
      default: "",
      required: true,
    },
  },
};
</script>

<style lang="scss">
$desktop: 1440px;
$tablet: 768px;
$mobile: 600px;
</style>